import { useLoadScript } from '@react-google-maps/api';

const libraries = ['places'];

function GoogleMapProvider({ children }) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    libraries,
  });

  if (!isLoaded) {
    return null;
  }

  return children;
}

export default GoogleMapProvider;
